/* CreateFileDetailsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateFileDetailsRenderer");

class CreateFileDetailsComponent extends EventEmitter {
    constructor(
        logger,
        userSession,
        osImages,
        osImageCatalogEntity,
        userService,
        initialData,
        osUpgradeInfoEntity
    ) {
        super();
        initialData = Object.entries(initialData || {}).reduce(
            (data, [key, value]) => Object.assign(data, {[key]: (value && value.value) || value}),
            {}
        );
        this._logger = logger;
        this._userService = userService;
        this._osImages = osImages;
        this._osImageCatalogEntity = osImageCatalogEntity;
        this._osUpgradeInfoEntity = osUpgradeInfoEntity;
        this._imageTypeFilter = {};
        this._vendorListFilter = {};

        this._orgId = userSession.activeOrganization.id;
        this._userId = userSession.user.id;
        this._authorizedActions = userSession.user.authorizedActions;
        this._renderer = new Renderer(this, initialData);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get osImages() {
        return this._osImages;
    }

    set osImages(data) {
        this.setOsImages(data);
    }

    setOsImages(data) {
        this._osImages = data;
    }

    get osImageCatalogEntity() {
        return this._osImageCatalogEntity;
    }

    set osImageCatalogEntity(entity) {
        this.setOsImageCatalogEntity(entity);
    }

    setOsImageCatalogEntity(entity) {
        this._osImageCatalogEntity = entity;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._osImages = undefined;
                this._osImageCatalogEntity = undefined;
                this._userService = undefined;
                this._renderer = undefined;
                this._context = undefined;
                this._authorizedActions = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "CreateFileDetailsComponent.shutdown() error");
            }
        );
    }

    submit(data = {}) {
        this._context.resolve({
            name: data.name || "",
            vendor: data.vendor || null,
            imageType: data.imageType || null,
            imageCatalog: data.catalog || null,
        });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/
    whenModelIsReady() {
        const orgId = this._orgId;
        return Promise.all([
            this.areCatalogsEnabled(orgId),
            this.isUserAuthorizedForCreate(orgId),
            this.loadImageCatalogs(orgId),
            this.loadOsUpdateInfo(orgId),
        ]).then(([catalogsEnabled, userAuthorised, imageCatalogs]) => ({
            imageCatalogs: catalogsEnabled && userAuthorised ? imageCatalogs : [],
        }));
    }

    getUserInfo() {
        return this._userService.get({userId: this._userId});
    }

    isUserAuthorizedForCreate() {
        if (this._authorizedActions.indexOf("osmCatalogWrite") >= 0) {
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
    }

    areCatalogsEnabled(orgId) {
        return this._osImageCatalogEntity.areCatalogsEnabled(orgId).catch((error) => {
            this._logger.warn({error});
            return false;
        });
    }

    loadImageCatalogs(orgId) {
        return this._osImageCatalogEntity.loadOsImageCatalogs(orgId).catch((error) => {
            this._logger.warn({error});
            return [];
        });
    }

    loadOsUpdateInfo(orgId) {
        return this._osUpgradeInfoEntity
            .loadOsUpgradeInfo(orgId, {imageTypeFilter: true, vendorListFilter: true})
            .then((osUpgradeInfo) => {
                if (osUpgradeInfo) {
                    this._imageTypeFilter = osUpgradeInfo.getImageTypeFilter() || {};
                    this._vendorListFilter = osUpgradeInfo.getVendorListFilter() || {};
                }
            })
            .catch((error) => {
                this._logger.warn({error});
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = CreateFileDetailsComponent;
